import { TextEditor } from "react-data-grid";
import type { Column } from "react-data-grid";
import { ImportarPlanilhaPrevisaoOrcamentariaItem } from "core/features/previsao-orcamentaria/typings/index";

export const columnsImportacaoPlanilhaPrevisao: readonly Column<ImportarPlanilhaPrevisaoOrcamentariaItem>[] =
  [
    {
      key: "mes",
      name: "Mês",
      width: 150,
    },
    {
      key: "categoria",
      name: "Categoria",
      width: 150,
    },
    {
      key: "valor",
      name: "Valor",
      width: 150,
    },
  ].map((col: Column<ImportarPlanilhaPrevisaoOrcamentariaItem>) => ({
    ...col,
    width: col.width || 250,
    resizable: true,
    editorOptions:
      col.editable === false
        ? null
        : {
            editOnClick: true,
          },
    editor: col.editor || TextEditor,
  }));
